
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sun } from "lucide-react";

import { CepSearchInput } from "./CepSearchInput";
import { SearchStepIndicator } from "./SearchStepIndicator";
import { IrradiationDataDisplay } from "./IrradiationDataDisplay";
import { DefaultHspOption } from "./irradiacao/DefaultHspOption";
import { LoadingIndicator } from "./irradiacao/LoadingIndicator";
import { useIrradiationSearch } from "./irradiacao/useIrradiationSearch";
import { DadosIrradiacao } from "@/types";

interface IrradiacaoCepInputProps {
  onDadosCarregados: (dados: DadosIrradiacao) => void;
  onVoltar?: () => void;
}

export const IrradiacaoCepInput = ({ onDadosCarregados, onVoltar }: IrradiacaoCepInputProps) => {
  const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", 
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

  const {
    loading,
    dadosIrradiacao,
    cepSearchInProgress,
    cepSearchCompleted,
    searchStep,
    usingDefaultHSP,
    handleCepSearch,
    handleFullSearch,
    useDefaultHSP
  } = useIrradiationSearch(meses, onDadosCarregados);

  return (
    <Card className="shadow-md animate-fade-in">
      <CardHeader className="bg-green-50/50">
        <CardTitle className="flex items-center gap-2 text-green-700">
          <Sun className="h-5 w-5 text-amber-500" /> 
          Dados de Irradiação Solar
        </CardTitle>
        <CardDescription>
          Insira o CEP para obter os dados de irradiação solar da região
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4 md:p-6">
        <CepSearchInput 
          onCepSearch={handleCepSearch}
          onFullSearch={handleFullSearch}
          loading={loading}
          cepSearchInProgress={cepSearchInProgress}
        />
        
        <SearchStepIndicator searchStep={searchStep} />
        
        {cepSearchCompleted && !dadosIrradiacao && !loading && (
          <DefaultHspOption onUseDefaultHSP={useDefaultHSP} />
        )}

        {loading && <LoadingIndicator />}
        
        {dadosIrradiacao && (
          <IrradiationDataDisplay dadosIrradiacao={dadosIrradiacao} />
        )}
      </CardContent>
    </Card>
  );
};
